export default [
    {
        type: 0,
        courseId: 1473,
        tips: "测试专场",
        class: "测试",
        time: "等你来...",
        companyName: "想看哪家互联网公司？",
        companyImg: "https://s20.lgstatic.com/growth/activity/20220215/1644896367714.png?x-oss-process=style/80",
        labels: [],
        btnName: "许愿占位",
        classImgUrl: "https://s20.lgstatic.com/growth/activity/20220221/1645433941957.png?x-oss-process=style/80"
    },
    {
        type: 1,
        courseId: 1475,
        tips: "产品专场",
        class: "产品",
        time: "等你来...",
        companyName: "想看哪家互联网公司？",
        companyImg: "https://s20.lgstatic.com/growth/activity/20220215/1644896367714.png?x-oss-process=style/80",
        labels: [],
        btnName: "许愿占位",
        classImgUrl: "https://s21.lgstatic.com/growth/activity/20220221/1645434027030.png?x-oss-process=style/80"
    },
    // {
    //     type: 2,
    //     courseId: 1472,
    //     tips: "前端专场",
    //     class: "研发",
    //     time: "2月17日 20:00 开播",
    //     companyName: "阿里巴巴",
    //     companyImg: "//www.lgstatic.com/thumbnail_300x300/i/image6/M01/57/D5/CioPOWE5bFSAcSwkAARBfBRceIg072.png",
    //     labels: ["电商平台", "晋升机制", "发展空间大"],
    //     btnName: "添加小助手，抢占内推名额",
    //     classImgUrl: "https://s21.lgstatic.com/growth/activity/20220215/1644912822739.png?x-oss-process=style/80"
    // },
    // {
    //     type: 3,
    //     courseId: 1471,
    //     tips: "Java专场",
    //     class: "研发",
    //     time: "2月17日 20:00 开播",
    //     companyName: "SHEIN",
    //     companyImg: "https://s21.lgstatic.com/growth/activity/20220215/1644918620792.png?x-oss-process=style/80",
    //     labels: ["跨境电商独角兽", "发展高速"],
    //     btnName: "添加小助手，抢占内推名额",
    //     classImgUrl: "https://s21.lgstatic.com/growth/activity/20220215/1644919091185.png?x-oss-process=style/80"
    // },
    {
        type: 3,
        courseId: 1471,
        tips: "研发专场",
        class: "研发",
        time: "等你来...",
        companyName: "想看哪家互联网公司？",
        companyImg: "https://s20.lgstatic.com/growth/activity/20220215/1644896367714.png?x-oss-process=style/80",
        labels: [],
        btnName: "许愿占位",
        classImgUrl: "https://s20.lgstatic.com/growth/activity/20220218/1645169542291.png?x-oss-process=style/80"
    },
    {
        type: 4,
        courseId: 1476,
        tips: "数据分析专场",
        class: "数据分析",
        time: "等你来...",
        companyName: "想看哪家互联网公司？",
        companyImg: "https://s20.lgstatic.com/growth/activity/20220215/1644896367714.png?x-oss-process=style/80",
        labels: [],
        btnName: "许愿占位",
        classImgUrl: "https://s21.lgstatic.com/growth/activity/20220215/1644912706840.png?x-oss-process=style/80"
    },
    {
        type: 5,
        courseId: 1474,
        tips: "运营专场",
        class: "运营",
        time: "等你来...",
        companyName: "想看哪家互联网公司？",
        companyImg: "https://s20.lgstatic.com/growth/activity/20220215/1644896367714.png?x-oss-process=style/80",
        labels: [],
        btnName: "许愿占位",
        classImgUrl: "https://s20.lgstatic.com/growth/activity/20220215/1644912940471.png?x-oss-process=style/80"
    }
]
